import configs from 'configs'
import {useLayout} from '../core'

const Footer = () => {
  const {classes} = useLayout()
  return (
    <div className='footer py-4 d-flex flex-lg-column'>
      <div
        className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <div className='text-dark order-2 order-md-1'>
          <span className='text-muted fw-bold me-2'>{new Date().getFullYear()} &copy;</span>
          <span className='text-gray-800 text-hover-primary'>{configs.appTitle}</span>
        </div>
      </div>
    </div>
  )
}

export {Footer}
